/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Seat_Type_ChangedInputs */



/**
* | output |
* | --- |
* | "Seat type changed" |
*
* @param {Audit_Details_Member_Seat_Type_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_seat_type_changed = /** @type {((inputs?: Audit_Details_Member_Seat_Type_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Seat_Type_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sitztyp geändert")
	return /** @type {LocalizedString} */ ("Seat type changed")
});